module.exports = __webpack_public_path__ + "fonts/PFBeauSansPro-Bold.62212d35.woff";